import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';

class DVCUserAPI extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCUsers';

  /**
   * Thực hiện đăng nhập vào dvc
   * hkcuong1 25.12.2025
   */
  loginDVC(model) {
    let request = {
      url: [this.getAPIUrl(), 'login-dvc'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Thực hiện đăng xuất khỏi DVC
   * @param {*} param Bearer Token trả về khi đăng nhập
   * @returns
   * hkcuong1 25.12.2025
   */
  logoutDVC(param) {
    let request = {
      url: [this.getAPIUrl(), 'logout-dvc'].join('/'),
      isCheckExpiredToken: false,
      data: { token: param },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra đơn vị đã đăng ký sử dụng KBĐT chưa
   * hkcuong 26.12.2025
   */
  async checkRegisterDVC(param) {
    let request = {
      url: this.getAPIUrl() + '/checkRegisterDVC',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new DVCUserAPI();
